module.exports = {
	OTA_SERVER_URL: 'http://ec2-18-136-198-123.ap-southeast-1.compute.amazonaws.com:18081',
	LANG: 'en',
	SUPPORT_SWITCHMODE: false
}


//////////////////
// WEBPACK FOOTER
// ./config/qa.config.js
// module id = OGwo
// module chunks = 1